import { render } from "./salary_admin_detail.vue?vue&type=template&id=216509ae&scoped=true"
import script from "./salary_admin_detail.vue?vue&type=script&lang=js"
export * from "./salary_admin_detail.vue?vue&type=script&lang=js"

import "./salary_admin_detail.vue?vue&type=style&index=0&id=216509ae&scoped=true&lang=css"
import "./salary_admin_detail.vue?vue&type=style&index=1&id=216509ae&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216509ae"]])

export default __exports__